import { decode } from "decode-formdata";
const getValidateFormData = (defaultOpts) => async (formData, info) => {
  const { validatorAdapter, onServerValidate } = defaultOpts || {};
  const runValidator = (propsValue) => {
    if (validatorAdapter && typeof onServerValidate !== "function") {
      return validatorAdapter().validate(propsValue, onServerValidate);
    }
    return onServerValidate(propsValue);
  };
  const data = decode(formData, info);
  const onServerError = runValidator({ value: data });
  return {
    errorMap: {
      onServer: onServerError
    },
    errors: onServerError ? [onServerError] : []
  };
};
export {
  getValidateFormData
};
//# sourceMappingURL=validateFormData.js.map
